import { createContext } from 'react';
// import { RMGAccent } from '../ColourRefs';

export const ThemeContext = createContext({
    dark: false,
});